/**
 * Vixxo Objects can contains request URL to get metadata from an object
 * This utility class help to obtain the ID
 * Currently only support the ID in the last section of the URL
 */
import { SortUtils } from './sort.utils';

export class RequestUrlUtils {
  /**
   * Get the ID from an URL
   * Currently the last chain of chars
   * @param {string} url
   * @returns {string}
   */
  public static getLastID(url: string): string {
    let start = url.lastIndexOf('/');
    return url.substr(start + 1, url.length);
  }

  /**
   * Get the Link Sources and iterates to get an specific property
   * returns the ID
   * @param {Array<any>} source
   * @param {string} property
   * @returns {string}
   */
  public static getUrlIDByProperty(source: Array<any>, property: string) {
    let propertyParam = source.find(r => {
      return r.rel === property;
    });
    if (propertyParam) {
      return RequestUrlUtils.getLastID(propertyParam.href);
    }
    return null;
  }

  /**
   * Maps the given response
   * @param {Array<any>} response
   * @param {string} propertyToMap
   * @param {string} propertyToSortBy
   */
  public static mapCollection(
    collection: Array<any>,
    propertyToMap: string,
    newProperty: string,
    idField?: string
  ) {
    idField = !idField ? 'id' : idField;
    // Model the result to be mapped.
    const mapRes = item => {
      return { [idField]: item[idField], [newProperty]: item[propertyToMap] };
    };
    // Mapping the result
    let result = collection.map(mapRes);
    // Return the result sorted by the given property 'propertyToSortBy'
    return SortUtils.sortCollection(result, newProperty);
  }
}
